
import vivewBase from './modules/zh/vivewBase'
import routerBase from './modules/zh/routerBase'
export default {
  ...vivewBase,
  ...routerBase
}
